import {Shape} from "three";
import {orderContourPoints} from "../../../../../../utils/processing/orderContourPoints";

const calcShapePos = (el, position, height, side) => {
    if (position === "RIGHT") {
        return {x: side.x - (el.z * side.x / height), y: el.y}
    } else if (position === "LEFT") {
        return {x: el.z * side.x / height, y: el.y}
    } else if (position === "BACK") {
        return {x: el.x, y: side.y - (el.z * side.y / height)}
    } else if (position === "FRONT") {
        return {x: el.x, y: el.z * side.y / height}
    } else {
        return {x: el.x, y: el.y}
    }
}

/** Круглый внутренний контур: shape из center+radius, без зависимости от порядка points. */
export const createCircleShape = (center, radius) => {
    const r = Number(radius);
    const cx = Number(center?.x);
    const cy = Number(center?.y);
    if (!Number.isFinite(r) || r <= 0 || !Number.isFinite(cx) || !Number.isFinite(cy)) {
        return null;
    }
    const shape = new Shape();
    shape.moveTo(cx + r, cy);
    shape.absarc(cx, cy, r, 0, Math.PI * 2, false);
    return shape;
};

export const createShape = (data, position, height, side) => {
    const shape = new Shape();
    const ordered = orderContourPoints(data);

    ordered.forEach((el, i) => {
        const point = calcShapePos(el, position, height, side)
        if (i === 0) shape.moveTo(point.x, point.y)
        if (el.arcParams) {
            shape.absarc(el.arcParams.x, el.arcParams.y, el.arcParams.radius, el.arcParams.startAngle, el.arcParams.endAngle, el.arcParams.clockwise)
        } else {
            shape.lineTo(point.x, point.y)
        }
    })

    return shape
}
